<div class="group-users-container" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<div class="tab" [ngClass]="{ selected: selectedTab === 'group_users' }" (click)="selectedTab = 'group_users'">
			{{ labels.lbl_geral_groups_users }}
		</div>
		<div class="tab" [ngClass]="{ selected: selectedTab === 'verification_order' }" (click)="selectedTab = 'verification_order'">
			{{ labels.lbl_geral_verification_order }}
		</div>
	</div>

	<div class="body-wrap">
		<ng-container *ngIf="!isLoadingPermissionData">
			<ng-container *ngIf="selectedTab === 'group_users'">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_groups_ad }}*</span>
					<select (change)="onGroupsChange($event)">
						<option value="">{{ labels.lbl_geral_selecione }}</option>
						<option *ngFor="let item of groupAdList" [value]="item.distinguishedName">{{ item.distinguishedName }}</option>
					</select>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_groups_permissions }}*</span>
					<!-- <select [(ngModel)]="selectedUsertype" (change)="onUsertypeChange($event)"> -->
					<select (change)="selectedUsertype = $event.target.value">
						<option value="">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="item.usertype" *ngFor="let item of usertypeList">{{ item.usertype }}</option>
					</select>
				</div>

				<div class="button-container">
					<div class="button" (click)="saveGroupAndPermission()">{{ labels.lbl_geral_atualizar }}</div>
				</div>

				<div class="border-tables" *ngIf="showTableEnduser">
					<div class="title-table">
						<span>{{ labels.lbl_geral_groups_permissions }}</span>
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_pesquisar }}</span>
						<input
							type="text"
							[(ngModel)]="searchText"
							[placeholder]="labels.lbl_geral_pesquisar"
							(keyup)="searchItemsEndusers()" />
					</div>
					<br />
					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>{{ labels.lbl_geral_nome }}</th>
									<th>{{ labels.lbl_cmdb_email }}</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let item of endusersList">
									<tr>
										<td>{{ item.full_name }}</td>
										<td>{{ item.email }}</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="selectedTab === 'verification_order'">
				<div *ngIf="!isLoadingData">
					<table>
						<thead>
							<tr>
								<th>{{ labels.lbl_geral_groups_ad }}</th>
								<th>{{ labels.lbl_geral_groups_permissions }}</th>
								<th>{{ labels.lbl_rep_ordem }}</th>
							</tr>
						</thead>
						<tbody>
							<tr
								*ngFor="let item of groupListDrag; let i = index"
								[draggable]="true"
								(dragstart)="onDragStart($event, i)"
								(dragover)="onDragOver($event, i)"
								(drop)="onDrop($event, i)"
								(dragend)="onDragEnd()">
								<td>{{ item.distinguishedName }}</td>
								<td>{{ item.usertype }}</td>
								<td>{{ i + 1 }}</td>
							</tr>
						</tbody>
					</table>

					<div class="button-container">
						<div class="button" (click)="updateSortOrder()">{{ labels.lbl_geral_atualizar }}</div>
					</div>
				</div>
			</ng-container>
		</ng-container>

		<cpi-dot-bounce-loading-effect *ngIf="isLoadingPermissionData" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
